import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicGmunu from "../Components/ProjPicGmunu";

const ProjectPageGmunu = () => {
    return (
        <>
            <Navbar />
            <ProjPicGmunu />
            <Footer />
        </>
    );
};

export default ProjectPageGmunu;
